export const STUDENTS_KEY = 'students-testing-tools-key';
export const LESSON_TYPE_KEY = 'lesson-type-testing-tools-key';
export const TECH_CHECK_KEY = 'tech-check-key';
export const ACT_AS_TEACHER_KEY = 'i-want-to-act-as-teacher';
